<template>
  <a-form :form="form">
    <a-row :gutter="16">
      <a-col :xs="{span: 24}" :lg="{span:12}">
        <a-form-item label="Date of WO">
          <a-date-picker
            placeholder="Select Date"
            :disabled="mode === 'Edit'"
            :format="getDefaultDateFormat"
            v-decorator="['tgl_buat', {rules: [{required: true}],
        initialValue: moment(initialData.informasi.tgl_buat, getDefaultDateFormat)}]"
          />
        </a-form-item>
        <a-form-item label="No PP">
          <v-select
            :clearable="false"
            class="m-select"
            :disabled="mode === 'Edit' || listWO.length>0"
            @input="handleNoPp"
            :options="wo_noPP"
            v-decorator="['no_pp', {rules: [{required: true}], initialValue: initialData.informasi.no_pp}]"
            label="no_pp"
          ></v-select>
          <!-- <a-select
            showSearch
            placeholder="Please select"
            v-decorator="['no_pp', {rules: [{required: true}], initialValue: initialData.informasi.no_pp}]"
            @change="handleNoPp"
            :disabled="mode === 'Edit'"
          >
            <a-select-option v-for="data in wo_noPP" :key="data.no_pp">{{data.no_pp}}</a-select-option>
          </a-select>-->
        </a-form-item>
        <a-form-item label="Supplier">
          <v-select
            class="m-select"
            :clearable="false"
            @input="handleSupplier"
            :options="wo_supplier"
            v-decorator="['id_supplier', {rules: [{required: true}], initialValue: initialData.informasi.id_supplier}]"
            label="nm_supplier"
          ></v-select>
          <!-- <a-select
            showSearch
            placeholder="Please select"
            v-decorator="['id_supplier', {rules: [{required: true}], initialValue: initialData.informasi.id_supplier}]"
            @change="handleSupplier"
            optionFilterProp="children"
            :filterOption="filterOption"
          >
            <a-select-option
              v-for="wo_supp in wo_supplier"
              :key="wo_supp.id_supplier"
            >{{wo_supp.nm_supplier}}</a-select-option>
          </a-select>-->
          <span><b>PKP</b> : {{ ispkp }}, <b>Domestik</b> : {{ isdomestik }}</span>
        </a-form-item>
      </a-col>
      <a-col :xs="{span: 24}" :lg="{span:12}">
        <a-form-item label="Location">
          <a-auto-complete
            class="certain-category-search"
            dropdownClassName="certain-category-search-dropdown"
            :dropdownMatchSelectWidth="false"
            placeholder="input here"
            optionLabelProp="value"
            v-decorator="['lokasi', {rules: [{required: true}], initialValue: initialData.informasi.lokasi}]"
          >
            <template slot="dataSource">
              <a-select-option v-for="item in getSites" :key="item.value">{{item.value}}</a-select-option>
            </template>
            <a-input>
              <a-icon slot="suffix" type="search" class="certain-category-icon" />
            </a-input>
          </a-auto-complete>
          <!-- <a-select
            showSearch
            v-decorator="['lokasi', {rules: [{required: true}], initialValue: initialData.informasi.lokasi}]"
          >
            <a-select-option
              v-for="item in getSites"
              :key="item.value"
              :value="item.value"
            >{{item.label}}</a-select-option>
          </a-select>-->
        </a-form-item>
        <!-- <a-form-item label>
          <a-checkbox
            @change="handleTax"
            :checked="initialData.informasi.check_tax"
            v-decorator="['check_tax', {rules: [{required: false}],initialValue: initialData.informasi.check_tax}]"
          >Tax</a-checkbox>
        </a-form-item> -->

        <!-- <a-form-item label>
          <a-input-number
            :min="1"
            :max="100"
            :formatter="value => `${value}%`"
            :parser="value => value.replace('%', '')"
            :disabled="!initialData.informasi.check_tax"
            v-decorator="['tax', {rules: [{required: false}],initialValue: initialData.informasi.tax}]"
          ></a-input-number>
        </a-form-item> -->

        <!-- <a-form-item label="Note">
          <a-textarea
            placeholder="Write the note here ... "
            :rows="4"
            v-decorator="['catatan', {initialValue: initialData.informasi.catatan}]"
          />
        </a-form-item> -->
        <!-- <div style="display:none">
        <a-form-item label="Vice President Finance Approval">
          <a-select
            v-decorator="['bod', {rules: [{required: true}], initialValue: initialData.informasi.bod}]"
            disabled
          >
            <a-select-option v-for="data in wo_bod" :key="data.tlc">{{data.tlc}} - {{data.nama}}</a-select-option>
          </a-select>
        </a-form-item>
        </div>-->
        <a-form-item label="Description">
          <a-input
            v-decorator="['deskripsi', {rules: [{required: false}], initialValue: initialData.informasi.deskripsi}]"
          ></a-input>
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";

export default {
  name: "Informasi",
  props: {
    data: {},
    mode: String,
    mata_uang: String,
    keuangan: {},
    listWO: {},
  },
  data() {
    return {
      activeProject: [],
      wo_noPP: [],
      wo_supplier: [],
      wo_bod: [],
      no_pp: String,
      supplier: String,
      kategori: String,
      id_pp: String,
      currency: null,
      trigger:{
        taxBarier : true
      },
      ispkp: " - ",
      isdomestik: " - "
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getKategori",
      "getActiveProject",
      "getUsedFor",
      "getAllKaryawan",
      "getDefaultDateFormat",
      "getAuth",
      "getSites"
    ]),
    initialData() {
      let informasi = {};

      if (this.data === undefined || this.data.length <= 0) {
        informasi = {
          kategori: "Project",
          id_pp: "",
          no_pp: "",
          id_supplier: "",
          tgl_buat: moment().format(this.getDefaultDateFormat),
          deskripsi: "",
          tax: 0,
          check_tax: false,
          catatan: "",
          lokasi: "",
          bod: "",
          tax_bearer: "0",
          tax_transaction: "1"
        };

        return { informasi };
      } else {
        if (this.data.tax > 0 || this.data.tax === undefined) {
          this.data.check_tax = true;
        } else {
          this.data.check_tax = false;
        }

        let supplier = _.filter(this.wo_supplier, {
          id_supplier: this.data.id_supplier
        });

        informasi = {
          id_wo: this.data.id_wo,
          id_pp: this.data.id_pp,
          no_pp: this.data.no_pp,
          id_supplier: supplier,
          no_wo: this.data.no_wo,
          kategori: this.data.kategori,
          tgl_buat: moment(this.data.tgl_buat).format(
            this.getDefaultDateFormat
          ),
          deskripsi: this.data.deskripsi,
          tax: this.data.tax,
          check_tax: this.data.check_tax,
          catatan: this.data.catatan,
          lokasi: this.data.lokasi,
          bod: this.data.bod,
          tax_bearer: this.data.tax_bearer,
          tax_transaction: this.data.tax_transaction
        };

        return { informasi };
      }
    },
    project() {
      if (this.kategori == "Non Project") {
        return this.getActiveProject.filter(
          obj =>
            obj.kategori &&
            obj.kategori.toLowerCase().indexOf("Non Project".toLowerCase()) >= 0
        );
      } else {
        return this.getActiveProject.filter(
          obj =>
            obj.kategori &&
            obj.kategori.toLowerCase().indexOf("Non Project".toLowerCase()) ===
              -1
        );
      }
    }
  },
  created() {
    this.$store.dispatch("FETCH_ACTIVE_PROJECT");
    this.$store.dispatch("FETCH_ALL_KARYAWAN");
    axios({
      method: "get",
      url: this.$serviceUrl + "wo/no_pp",
      params: {
        "X-API-KEY": this.getAuth.apikey,
        tlc: this.getAuth.username
      },
      auth: {
        username: this.getAuth.username,
        password: this.getAuth.password
      }
    })
      .then(response => {
        this.wo_noPP = response.data.data;
      })
      .catch(err => {
        this.displayMessage("error-connection");
      });

    axios({
      method: "get",
      url: this.$serviceUrl + "wo/supplier",
      params: {
        "X-API-KEY": this.getAuth.apikey,
        tlc: this.getAuth.username
      },
      auth: {
        username: this.getAuth.username,
        password: this.getAuth.password
      }
    })
      .then(response => {
        this.wo_supplier = response.data.data;
      })
      .catch(err => {
        this.displayMessage("error-connection");
      });

    axios({
      method: "get",
      url: this.$serviceUrl + "bod",
      params: {
        "X-API-KEY": this.getAuth.apikey
      },
      auth: {
        username: this.getAuth.username,
        password: this.getAuth.password
      }
    })
      .then(response => {
        this.wo_bod = response.data.bod;
      })
      .catch(err => {
        this.displayMessage("error-connection");
      });

    /* this.form.setFieldsValue(
      "id_supplier",
      this.initialData.informasi.id_supplier
    ); */
  },
  methods: {
    moment,
    handleKategori(e) {
      this.initialData.informasi.kategori = e.target.value;
      this.kategori = e.target.value;
    },
    handleProject(value) {
      let filter = this.project.filter(
        obj => obj.kode_project.toLowerCase().indexOf(value.toLowerCase()) >= 0
      );

      return filter;
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          //this.form.resetFields()
          this.displayMessage("form-warning");
          return;
        }
        
        let supplier = _.filter(this.wo_supplier, {
          nm_supplier: values.id_supplier
        });

        let id_pp = _.filter(this.wo_noPP, {
          no_pp: values.no_pp
        });

        if (this.mode === "Edit") {
          values.id_wo = this.data.id_wo;
          values.no_wo = this.data.no_wo;
          values.id_supplier = this.data.id_supplier;
          values.id_pp = this.data.id_pp;
          values.kurs = id_pp.length>0 ? id_pp[0].kurs : this.keuangan[0].kurs;
          values.catatan = this.data.catatan;
        } else {
          values.id_pp = id_pp[0].id_pp;
          values.kurs = id_pp[0].kurs;
          values.id_supplier = supplier[0].id_supplier;
        }

        let dataValues = {
          ...values,
          tgl_buat: moment(values.tgl_buat).format(this.getStandartFormatDate)
        };
        Event.$emit("woData", {
          informasi: dataValues,
          mata_uang: this.currency ? this.currency : this.mata_uang
        });
      });
    },
    handleNoPp(data) {
      this.currency = data.currency;

      if (this.mode === "Edit") {
        this.data.id_pp = data.id_pp;
      } else {
        this.initialData.informasi.id_pp = data.id_pp;
      }
      this.initialData.informasi.bod = data.bod;
      this.form.setFieldsValue({ no_pp: data.no_pp });
    },
    handleSupplier(idSpl) {
      let filter = _.filter(
        this.wo_supplier,
        obj =>
          obj.id_supplier==idSpl.id_supplier
      );

      if(filter.length>0){
        this.ispkp = filter[0].ispkp=='1' ? 'Yes': (filter[0].ispkp=='-'? '-' :'No')
        this.isdomestik = filter[0].lokasi=="LN" ? "No": (filter[0].lokasi=='-' ? '-' :'Yes')
      }

      this.initialData.informasi.id_supplier = idSpl.id_supplier;
      if (this.mode === "Edit") {
        this.data.id_supplier = idSpl.id_supplier;
      }
      this.form.setFieldsValue({ id_supplier: idSpl.nm_supplier });
    },
    handleBOD(data) {
      let filter = this.wo_bod.filter(
        obj => obj.tlc.toLowerCase().indexOf(data.toLowerCase()) >= 0
      );

      return filter;
    },
    handleTax(e) {
      this.initialData.informasi.check_tax = e.target.checked;
      if (this.initialData.informasi.check_tax) {
        this.form.setFieldsValue({ tax: "10" });
      } else {
        this.form.setFieldsValue({ tax: "0" });
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    ChangetaxTransaction(val){
      this.initialData.informasi.tax_bearer = "0";
      this.trigger.taxBarier = val.target.value=="1" ? true : false;
    }
  },
  watch: {
    data(){
      if(this.data){
        if(this.data.tax_transaction=="1"){
          this.trigger.taxBarier = true;
        }else{
          this.trigger.taxBarier = false;
        }
      }
    }
  }
};
</script>

<style>
</style>